import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, TemplateRef, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NetworkService } from 'src/app/core/services/network.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogService } from 'src/app/shared/services/confirm-dialog.service';

@Component({
  selector: 'app-changeover-modal',
  templateUrl: './changeover-modal.component.html',
  styleUrls: ['./changeover-modal.component.scss']
})
export class ChangeoverModalComponent implements OnInit, OnChanges {

  @ViewChild('editLineChangeover', {static: false}) editModalChangeover: TemplateRef<Object>;
  @Input() editLineObj: any = {};
  @Output() changeoverComplete = new EventEmitter<void>();

  productList: any[] = [];
  areaTypeList: any[] = [];
  productCode: any = '0';  // Use string to match option values
  areaType: any = '0';     // Use string to match option values
  lineName: any = "";
  isSubmitEnabled: boolean = false;
  modalRef: any; // Store reference to the modal instance

  constructor(
    private netWorkSer: NetworkService, 
    private loaderService: LoaderService, 
    public modalService: ModalService, 
    private toastr: ToastrService, 
    private translate: TranslateService, 
    private confirmDialogService: ConfirmDialogService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Load data if editLineObj is already available
    if (this.editLineObj?.id) {
      this.loadProductList();
      this.loadAreaTypeList();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Load data when editLineObj changes
    if (changes['editLineObj'] && this.editLineObj?.id) {
      this.loadProductList();
      this.loadAreaTypeList();
    }
  }

  openModal() {
    // Reset selections immediately when modal opens
    this.productCode = '0';  // Use string to match option value
    this.areaType = '0';     // Use string to match option value
    this.isSubmitEnabled = false;
    
    // Load data if not already loaded (fallback)
    if (!this.productList.length || !this.areaTypeList.length) {
      this.loadProductList();
      this.loadAreaTypeList();
    }
    
    // Open the modal and store the reference
    this.modalRef = this.modalService.open(this.editModalChangeover);
  }

  closeModal(modalRef?: any) {
    // Use passed modalRef or stored reference
    const modal = modalRef || this.modalRef;
    
    // Dismiss the modal
    if (modal) {
      modal.dismiss();
      this.modalRef = null;
    }
  }

  checkSubmitEnabled() {
    // Enable submit button only if both productCode and areaType are selected
    this.isSubmitEnabled = this.productCode !== '0' && this.productCode !== 0 && this.productCode !== '' && 
                          this.areaType !== '0' && this.areaType !== 0 && this.areaType !== '';
  }

  loadProductList() {
    if (!this.editLineObj?.id) {
      this.productList = [];
      return;
    }

    let url = 'GetLineProductList/' + this.editLineObj.id;
    this.loaderService.display(true);
    
    this.netWorkSer.httpReq('get', url).subscribe(resp => {
      this.loaderService.display(false);
      
      if (resp.data.length > 0) {
        this.productList = resp.data;
        //unique Products
        let productCodes = this.productList.filter((elem: any, index: any) =>
          this.productList.findIndex((obj: any) => obj.productCode === elem.productCode) === index
        );

        this.productList = productCodes;

        for (let index = 0; index < this.productList.length; index++) {
          const element = this.productList[index];
          element.text = element.productCode;
          element.id = element.productCode;
        }
      } else {
        this.productList = [];
      }
    }, error => {
      this.loaderService.display(false);
      this.productList = [];
    });
  }

  loadAreaTypeList() {
    if (!this.editLineObj?.id) {
      this.areaTypeList = [];
      return;
    }

    let obj: any = {
      "lineId": this.editLineObj.id,
      "userInput": null,
      "isDisabled": false
    }
    let url = 'GetAMAreaData';
    this.loaderService.display(true);
    
    this.netWorkSer.httpReq('post', url, '', obj).subscribe(resp => {
      this.loaderService.display(false);
      
      if (resp.data.length > 0) {
        let tempAMAreaList: Array<any> = resp.data;
        
        // Get unique areaType values from tempAMAreaList
        const uniqueAreaTypes = [...new Set(tempAMAreaList.map((item: any) => item.areaType))];
        
        // Create the distinct areaType list with proper structure
        this.areaTypeList = uniqueAreaTypes.map((areaType: any) => ({
          areaType: areaType,
          text: areaType,
          id: areaType
        }));

      } else {
        this.areaTypeList = [];
      }
    }, error => {
      this.loaderService.display(false);
      this.areaTypeList = [];
    });
  }

  onChangedProductValue(selectedProductCode: any) {
    this.productCode = selectedProductCode;
    this.checkSubmitEnabled();
  }

  onChangedAreaTypeValue(selectedAreaType: any) {
    this.areaType = selectedAreaType;
    this.checkSubmitEnabled();
  }

  onSubmit(form: any, modalRef: any) {
    this.lineName = this.editLineObj.lineName;
    this.confirmDialogService.setConfirmation(this.translate.instant('Admin.manualproductchangeover'), 'manualproductchangeover', 'admin', () => {
      this.getMLOChangeOverValue();
      this.closeModal();
    }, function () {
      // Cancel callback
    });
  }

  getMLOChangeOverValue() {
    if (this.productCode != '' && this.areaType != '' && this.lineName != '') {
      this.loaderService.display(true);
      this.netWorkSer.httpReq('get', 'MLOChangeOver/' + this.productCode + '/' + this.areaType + '/' + this.lineName).
        subscribe((resp) => {
          if (resp.Status != "") {
            if (resp.Status.includes('Fail')) {
              this.toastr.error('', resp.Status, environment.toastOptions);
            } else {
              this.toastr.success('', resp.Status, environment.toastOptions);
            }
            this.loaderService.display(false);
            this.changeoverComplete.emit();
          }
        }, error => {
          this.loaderService.display(false);
          this.toastr.error('', "Error Occurred", environment.toastOptions);
        });
    }
  }
}
